import { AllowedReducer } from '@leverege/api-redux';
import { Dialogs } from '@leverege/ui-elements';
import { Context } from '@leverege/plugin';
import { DataSources } from '@leverege/ui-attributes';
import { GlobalState } from '@leverege/ui-redux';
import RecovrSales from '../../util/RecovrSales';
import SalesFlow from '../../views/salesFlow/SalesFlow';
import C from '../../views/salesFlow/Constants';
export default {
  id: 'recovr.pendingSaleMessage',
  name: 'Send SMS About this sale',
  layout: {
    sort: 'recovrSaleActions.zPendingSaleMessage',
    sectionName: 'RecovR Sale Actions'
  },
  matches: [{
    use: ['contextMenu', 'mobileActionBar'],
    path: 'company.locations.sales',
    objectType: 'sale'
  }, {
    use: ['contextMenu', 'mobileActionBar'],
    path: 'company.sales',
    objectType: 'sale'
  }, {
    use: ['contextMenu', 'mobileActionBar'],
    path: 'location.sales',
    objectType: 'sale'
  }, {
    use: ['contextMenu', 'mobileActionBar'],
    path: 'sale',
    objectType: 'sale'
  }, {
    client: 'MapBoxRolloverSelectionPointer',
    use: ['contextMenu', 'mobileActionBar']
  }],
  prepare: async cxt => {
    const targets = Context.getTargetsOfType(cxt, 'sale');
    if (targets?.length !== 1 || targets[0]?.data?.data?.state !== 'pending' || targets[0]?.data?.data?.type !== 'vehicle-only' && targets[0]?.data?.data?.type !== 'vehicle-wholesale' && targets[0]?.data?.data?.type !== 'dealer-trade') {
      return false;
    }
    const actions = DataSources.getActions(targets[0]);
    return RecovrSales.canSendPendingSaleMessage({
      saleId: targets[0].id,
      actions
    });
  },
  isPrepared: cxt => {
    const targets = Context.getTargetsOfType(cxt, 'sale');
    if (targets?.length !== 1 || targets[0]?.data?.data?.state !== 'pending' || targets[0]?.data?.data?.type !== 'vehicle-only' && targets[0]?.data?.data?.type !== 'vehicle-wholesale' && targets[0]?.data?.data?.type !== 'dealer-trade') {
      return true;
    }
    const a = AllowedReducer.get(GlobalState.get(), targets[0]?.id);
    return a.sendPendingSaleMessage != null;
  },
  handles: cxt => {
    const targets = Context.getTargetsOfType(cxt, 'sale');
    if (targets?.length !== 1) {
      return false;
    }
    const a = AllowedReducer.get(GlobalState.get(), targets[0]?.id);
    return a.sendPendingSaleMessage === true && targets[0]?.data?.data?.state === 'pending' && (targets[0]?.data?.data?.type === 'vehicle-only' || targets[0]?.data?.data?.type === 'vehicle-wholesale' || targets[0]?.data?.data?.type === 'dealer-trade');
  },
  appearance: () => {
    return {
      icon: '@icon:icon-chat',
      name: 'Send SMS About This Sale'
    };
  },
  perform: async props => {
    const {
      context,
      context: {
        clientProps: {
          actions
        }
      }
    } = props;
    const targets = Context.getTargetsOfType(context, 'sale');
    const saleId = targets[0].data.id;
    const saleType = targets[0].data.data.type;
    const vehicleId = targets[0].data.data.vehicle.id;
    const vehicleObjRef = {
      id: vehicleId,
      type: 'vehicle',
      ref: actions.getInterfaceUrl().replace('sales', 'vehicles').replace(`/${saleId}`, ''),
      data: null
    };
    let vehicle = GlobalState.get().models.lookup[vehicleId];
    if (!vehicle) {
      const actions = DataSources.getActions(vehicleObjRef);
      vehicle = await GlobalState.dispatch(actions.get());
    }
    vehicleObjRef.data = vehicle;
    const vehicles = [vehicleObjRef];
    Dialogs.show({
      id: C.SALE_TYPES.VEHICLE_ONLY,
      component: SalesFlow,
      props: {
        ...props,
        actions,
        vehicles,
        flowType: 'pending-sale',
        saleId,
        saleType
      }
    });
  }
};